var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_61912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_61912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 22,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.6665,
    width: 21.3333,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_61912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 0H18.6668V16H-2.6665V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 9.77768V11.111H18.6668V9.77768H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 12.2223V13.5557H18.6668V12.2223H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 4.88901V6.22234H18.6668V4.88901H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 14.6667V16H18.6668V14.6667H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 7.33334V8.66668H18.6668V7.33334H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 0V1.33333H18.6668V0H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.6665 2.44434V3.77767H18.6668V2.44434H-2.6665Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.6665,
    width: 13.3333,
    height: 8.66667,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.51755 1.95914L-2.00147 2.2984L-1.83809 1.69466L-2.2679 1.31205H-1.70651L-1.51823 0.819336L-1.29745 1.31205H-0.818874L-1.1949 1.69466L-1.04932 2.2984L-1.51755 1.95914ZM1.14895 1.95914L0.665035 2.2984L0.828411 1.69466L0.3986 1.31205H0.959992L1.14828 0.819336L1.36906 1.31205H1.84763L1.47161 1.69466L1.61718 2.2984L1.14895 1.95914ZM3.3317 2.2984L3.81562 1.95914L4.28385 2.2984L4.13827 1.69466L4.5143 1.31205H4.03573L3.81494 0.819336L3.62666 1.31205H3.06527L3.49508 1.69466L3.3317 2.2984ZM6.48229 1.95914L5.99837 2.2984L6.16174 1.69466L5.73193 1.31205H6.29333L6.48161 0.819336L6.70239 1.31205H7.18096L6.80494 1.69466L6.95051 2.2984L6.48229 1.95914ZM-2.00163 4.96506L-1.51771 4.6258L-1.04949 4.96506L-1.19506 4.36132L-0.819037 3.97871H-1.29761L-1.51839 3.486L-1.70667 3.97871H-2.26807L-1.83826 4.36132L-2.00163 4.96506ZM1.14895 4.6258L0.665035 4.96506L0.828411 4.36132L0.3986 3.97871H0.959992L1.14828 3.486L1.36906 3.97871H1.84763L1.47161 4.36132L1.61718 4.96506L1.14895 4.6258ZM3.3317 4.96506L3.81562 4.6258L4.28385 4.96506L4.13827 4.36132L4.5143 3.97871H4.03573L3.81494 3.486L3.62666 3.97871H3.06527L3.49508 4.36132L3.3317 4.96506ZM6.48229 4.6258L5.99837 4.96506L6.16174 4.36132L5.73193 3.97871H6.29333L6.48161 3.486L6.70239 3.97871H7.18096L6.80494 4.36132L6.95051 4.96506L6.48229 4.6258ZM-2.00163 7.63173L-1.51771 7.29247L-1.04949 7.63173L-1.19506 7.02799L-0.819037 6.64538H-1.29761L-1.51839 6.15267L-1.70667 6.64538H-2.26807L-1.83826 7.02799L-2.00163 7.63173ZM1.14895 7.29247L0.665035 7.63173L0.828411 7.02799L0.3986 6.64538H0.959992L1.14828 6.15267L1.36906 6.64538H1.84763L1.47161 7.02799L1.61718 7.63173L1.14895 7.29247ZM3.3317 7.63173L3.81562 7.29247L4.28385 7.63173L4.13827 7.02799L4.5143 6.64538H4.03573L3.81494 6.15267L3.62666 6.64538H3.06527L3.49508 7.02799L3.3317 7.63173ZM6.48229 7.29247L5.99837 7.63173L6.16174 7.02799L5.73193 6.64538H6.29333L6.48161 6.15267L6.70239 6.64538H7.18096L6.80494 7.02799L6.95051 7.63173L6.48229 7.29247ZM8.66503 2.2984L9.14895 1.95914L9.61718 2.2984L9.47161 1.69466L9.84763 1.31205H9.36906L9.14828 0.819336L8.95999 1.31205H8.3986L8.82841 1.69466L8.66503 2.2984ZM9.14895 4.6258L8.66503 4.96506L8.82841 4.36132L8.3986 3.97871H8.95999L9.14828 3.486L9.36906 3.97871H9.84763L9.47161 4.36132L9.61718 4.96506L9.14895 4.6258ZM8.66503 7.63173L9.14895 7.29247L9.61718 7.63173L9.47161 7.02799L9.84763 6.64538H9.36906L9.14828 6.15267L8.95999 6.64538H8.3986L8.82841 7.02799L8.66503 7.63173ZM-0.184379 3.29247L-0.668299 3.63173L-0.504922 3.02799L-0.934733 2.64538H-0.373342L-0.185055 2.15267L0.0357256 2.64538H0.514296L0.138272 3.02799L0.283846 3.63173L-0.184379 3.29247ZM1.99837 3.63173L2.48229 3.29247L2.95051 3.63173L2.80494 3.02799L3.18096 2.64538H2.70239L2.48161 2.15267L2.29333 2.64538H1.73193L2.16174 3.02799L1.99837 3.63173ZM5.14895 3.29247L4.66503 3.63173L4.82841 3.02799L4.3986 2.64538H4.95999L5.14828 2.15267L5.36906 2.64538H5.84763L5.47161 3.02799L5.61718 3.63173L5.14895 3.29247ZM-0.668299 6.2984L-0.184379 5.95914L0.283846 6.2984L0.138272 5.69466L0.514296 5.31205H0.0357256L-0.185055 4.81934L-0.373342 5.31205H-0.934733L-0.504922 5.69466L-0.668299 6.2984ZM2.48229 5.95914L1.99837 6.2984L2.16174 5.69466L1.73193 5.31205H2.29333L2.48161 4.81934L2.70239 5.31205H3.18096L2.80494 5.69466L2.95051 6.2984L2.48229 5.95914ZM4.66503 6.2984L5.14895 5.95914L5.61718 6.2984L5.47161 5.69466L5.84763 5.31205H5.36906L5.14828 4.81934L4.95999 5.31205H4.3986L4.82841 5.69466L4.66503 6.2984ZM7.81562 3.29247L7.3317 3.63173L7.49508 3.02799L7.06527 2.64538H7.62666L7.81494 2.15267L8.03573 2.64538H8.5143L8.13827 3.02799L8.28385 3.63173L7.81562 3.29247ZM7.3317 6.2984L7.81562 5.95914L8.28385 6.2984L8.13827 5.69466L8.5143 5.31205H8.03573L7.81494 4.81934L7.62666 5.31205H7.06527L7.49508 5.69466L7.3317 6.2984Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -2.6665,
    width: 21.3333,
    height: 16,
    fill: "url(#paint0_linear_28_61912)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_61912",
    x1: 8.00016,
    y1: 0,
    x2: 8.00016,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215776,
    stopColor: "#9A9A9A",
    stopOpacity: 0.848957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_61912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/Flags.fb5e69d499fa947b4b8c1787132401be.svg";
export { ForwardRef as ReactComponent };